__turbopack_context__.v({
  "accountButton": "MQPpmq_accountButton",
  "compactAccountButton": "MQPpmq_compactAccountButton",
});
